export const selectedItemToTitle = (selectedItem) => {
  switch (selectedItem) {
    case "healthlink":
      return "Healthlink Immunisations";
    case "manual":
      return "Manual Immunisations";
    case "declined":
      return "Declined & Not Given";
    case "recall":
      return "Recall";
    default:
      return "Immunisations";
  }
};
